module.exports = __webpack_public_path__ + "img/investor_gate@2x.2cab86ad.png";